

/**
 * @author Valerio Chiodino <valerio.chiodino@openmindonline.it>
 * @copyright Openmind S.r.l. 2017
 *
 * This component toggles CSS classes on differet targets on a data-attribute configuration basis.
 *
 * Data options:
 *
 * dataom-toggle               string - the class(es) to toggle.
 * dataom-toggle-clear         string - if present these are the classes that will be removed on 'clear-target'.
 * dataom-toggle-clear-target  string - clear classes target.
 * dataom-toggle-clear-parent  string - if defined, the scope where to find the "clear-context".
 * dataom-toggle-context       string - if present 'parent' is ignored and the context is used instead.
 * dataom-toggle-enabled       string - comma separated list of resolutions (xs, sm, md, lg) - if provided, it will enable
                                      "dataom-toggle" only in specified resolutions.
 * dataom-toggle-parent        string - if parent is given, target is found starting from this element.
 * dataom-toggle-parent-class  string - if 'parent' element is present it will recieve this class(es) after the toggle
                                      occurs.
 * dataom-toggle-self-class    string - the class(es) the clicked element receives after the toggle occurs.
 * dataom-toggle-self-multiple        string - multiple triggers swith classes in self-class
 * dataom-toggle-target-multiple        string - multiple targets swith classes in toggle
 * dataom-toggle-target        string - the target of the script.
 * data-toggle-remove      string - comma separated list of events (click, scroll) that will trigger the toggle of the class
 * data-toggle-delegate     string - the class or the id of the element that will also trigger the toggle of the class
 * data-toggle-delegate-enabled     string - comma separated list of resolutions (xs, sm, md, lg) - if provided, the delegate function is fired only on the given resolution
 * Notes:
 * - The difference between "parent" and "context" is that the former must be a common parent between
 *   the toggle and its target and the latest uses an "absolute" aproach, scanning the whole DOM.
 *
 * - If "enable" is not provided then it is assumed that the element will be a toggle throughout
 *   all supported resolutions.
 */

(function($, App, Utils, Components) {
  'use strict';

  var logger = new Logger("DataToggle");

  Components.create("DataToggle", {


    /**
     * Bind against framework-wide events.
     */
    bindEvents: function() {
      Utils.Ajax.on(Utils.Ajax.Events.Success, function() {
        Components.DataToggle.bindTogglers();
      });

      Utils.Responsive.on(Utils.Responsive.Events.ResolutionEnter, function(e, res) {
        Components.DataToggle.bindTogglers();
      });

    },


    /**
     * Bind specific events and objects.
     */
    bindTogglers: function() {
      $('*[data-om-toggle]').not('[data-om-toggle=""]').off('click.dt deselect.dt').on('click.dt deselect.dt', function(e) {

        if (e.target === 'a' && ($(e.target).attr('href') && $(e.target).attr('href') === '#')) {
          e.preventDefault();
          e.stopPropagation();
        }
        // This will prevent double events
        if ($(e.target).is("label")) { return true; }

        var
          self          = $(this),
          enable        = self.data('omToggleEnable');

        if (enable && enable.indexOf(Utils.Responsive.getCurrentResolution().label) == -1 ) {
          self.off('click.dt deselect.dt');
          return;
        }

        var
          cssClass      = self.data('omToggle'),
          tSelector     = self.data('omToggleTarget'),
          selfClass     = self.data('omToggleSelfClass') || 'active',
          selfMultipleSelector     = self.data('omToggleSelfMultiple'),
          targetMultipleSelector     = self.data('omToggleTargetMultiple'),
          parent        = self.data('omToggleParent'),
          parentClass   = self.data('omToggleParentClass'),
          context       = self.data('omToggleContext'),
          clear         = self.data('omToggleClear'),
          clearTarget   = self.data('omToggleClearTarget'),
          clearParent   = self.data('omToggleClearParent'),
          toggleRemove  = self.data('omToggleRemoveOn'),
          toggleDelegate = self.data('omToggleDelegate'),
          toggleDelegateEnabled = self.data('omToggleDelegateEnabled'),
          parent        = parent ? self.parent(parent) : self,
          target        = parent && (tSelector.match('^#') == null) ? parent.find(tSelector) : $(tSelector),
          loginPopover  = self.data('omToggleLoginpopover'),
          switchControl = self.find('input[type="radio"], input[type="checkbox"]');

        if (context && target.length == 0) {
          target = $(context).find(tSelector);
        }

        var toggle = !target.hasClass(cssClass);
        if (switchControl.length != 0 && !switchControl.is(':disabled')) {
          toggle = switchControl.is(':checked');
        }

        // Clearing classes
        if (clear) {

          if (clearTarget) {
            var $clear = $(clearTarget);
            if (clearParent) {
              $clear = target.closest(clearParent).find(clearTarget);
            }
            $clear.removeClass(clear + ' ' + selfClass);
          }

          self.removeClass(clear + ' ' + selfClass);
          parent.removeClass(clear);
          target.removeClass(clear);
        }

        if (selfClass) {
          if(selfMultipleSelector){
            document.querySelectorAll(selfMultipleSelector).forEach(function(btn){
              btn.classList.remove(selfClass);
            })
            self.toggleClass(selfClass, self);
          } else {
          self.toggleClass(selfClass, toggle);
          }
        }

        if (parentClass) {
          parent.toggleClass(parentClass, toggle);
        }

        logger.d(`Turning ${toggle ? 'on' : 'off'} ${cssClass} on target:`, target)

        if(targetMultipleSelector){
          document.querySelectorAll(targetMultipleSelector).forEach(function(tg){
            tg.classList.toggle(cssClass);
          })
        } else {
          target.toggleClass(cssClass, toggle);
        }

        

        Components.DataToggle.bindRemove(toggleRemove, toggle, self);

        if (toggleDelegate && (!toggleDelegateEnabled | (toggleDelegateEnabled && toggleDelegateEnabled.indexOf(Utils.Responsive.getCurrentResolution().label) !== -1))) {
          Components.DataToggle.delegate(toggleDelegate, toggle, self);
        }

        Components.trigger('class:changed', [toggle, self]);

      });
    },

    delegate: function (el, classAdded , trigger) {
      var $delegatedEl = $(el);
      var $trigger = $(trigger);

      if (classAdded) {
        $delegatedEl.on('click.dt', function (e) {
          $delegatedEl.off('click.dt');
          $trigger.trigger('click.dt');
        });
      } else {
        $delegatedEl.off('click.dt');
      }
    },

    bindRemove: function (events, classAdded, trigger) {

      var scopedEvents = ['keydown.dt', 'resize.dt'];
      if (events) {
        var eventsArray = events ? events.split(",") : '';

        for (var i = 0; i < eventsArray.length; i++) {
          var reference = eventsArray[i];
          scopedEvents.push((reference += '.dt' ));
        }
      }

      var $trigger = $(trigger);

      if (classAdded) {
        App.Window.on(scopedEvents.toString().replace(',', ' '), function (e) {
          if (e.type === 'keydown' && e.keyCode !== 27 ) {
            return;
          }
          App.Window.off(scopedEvents.toString().replace(',', ' '));
          $trigger.trigger('click.dt');
        });
      } else {
        App.Window.off(scopedEvents.toString().replace(',', ' '));
      }

    },


    /**
     * Initializes the component.
     */
    init: function() {
      Components.DataToggle.bindEvents();
      Components.DataToggle.bindTogglers();
    }

  });

})(jQuery,
  window.App,
  window.App.Utils,
  window.App.Components
);